import { BaseError } from './base';

export class WalletAccountAlreadyVerifiedError extends BaseError {
  constructor(address: string) {
    super({
      cause: null,
      code: 'wallet_account_already_verified_error',
      docsUrl: null,
      name: 'WalletAccountAlreadyVerifiedError',
      shortMessage: `Wallet account ${address} is already verified`,
    });
  }
}
